import { fetchCurrentUser } from '@auth/proxy-auth';
import { CurrentUserDTO } from '@app/auth/dto';
import { useCallback, useState } from 'react';

/**
 * Manages the current authenticated user.
 *
 * - `user` — React state for rendering.
 * - `updateUserData` — fetches /me and updates state; safe to call at any time.
 */
const useSessionUser = () => {
  const [user, setUser] = useState<CurrentUserDTO | undefined>();

  const updateUserData = useCallback(async () => {
    try {
      const userData = await fetchCurrentUser();
      if (userData) {
        setUser(userData);
      }
    } catch {
      // ignore
    }
  }, []);

  return { user, updateUserData };
};

export { useSessionUser };
